import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getReportingCompanyParagraphs = (data) => {
  const {
    poaData,
    reportingCompanyName,
    reportingCompanyAppointedDate,
    reportingCompanyAppointer,
  } = data;

  const header = getSectionHeader("Reporting Company");

  let paragraphs = [
    {
      condition: true,
      segments: [
        {
          text: "The CIR calculations for the group have been prepared on the basis that there is no nominated reporting company in place for the period. As a result, the calculations do not reflect any reactivations or the calculation of any unused allowance, and are prepared on the basis of the fixed ratio (as no group ratio election can be made) with a pro-rata allocation of any disallowed amount. No CIR return has been prepared, on the basis that it is only possible to submit a return where there is a nominated reporting company in place.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  if (!poaData?.reporting_company) {
    return [header, ...generateSectionParagraphs(paragraphs)];
  }

  paragraphs = [
    {
      condition: true,
      segments: [
        {
          text: "[Please note - a copy of the reporting company nomination should be stored in AODOCs before filing a CIR return]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "The return is being submitted by ",
          font: defaultFontNormal,
        },
        {
          text: reportingCompanyName,
          font: defaultFontNormal,
        },
        {
          text: " based on our understanding that this company was nominated as the reporting company for the group on ",
          font: defaultFontNormal,
        },
        {
          text: reportingCompanyAppointedDate,
          font: defaultFontNormal,
        },
        {
          text: ". A group can only submit a Corporate Interest Restriction return where a reporting company has been nominated, and HMRC does not accept returns filed by a group where no valid nomination is in place. Conversely, where such a nomination is in place, the group must submit a Corporate Interest Restriction return.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "In order to be valid, the group reporting company nomination must, inter alia, have been submitted within the period of 12 months",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "1",
          superScript: true,
          font: defaultFontNormal,
        },
        {
          text: " beginning with the end of the period of account of the worldwide group and have been authorised by at least 50% of eligible companies during the period of nomination. HMRC has the power to appoint a reporting company within 4 years from the end of the period of account of the worldwide group under Para 4, Schedule 7A, TIOPA 2010. However, as set out in Agent Brief 109 issued in June 2023, HMRC ",
          font: defaultFontNormal,
        },
        {
          text: "“will no longer appoint a reporting company for a group simply because the group has not made its own appointment by their deadline, and later realises that it would be beneficial to have a reporting company”",
          font: defaultFontItalic,
        },
        {
          text: ". As such, we recommend reviewing the reporting company nomination, confirming it is valid, and making sure it is retained on file.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: reportingCompanyAppointer === "Company",
      segments: [
        {
          text: "As the nomination was made by the group, it continues to have effect whilst the reporting company remains an active UK group company, unless it is revoked by more than 50% of eligible group companies.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: reportingCompanyAppointer === "HMRC",
      segments: [
        {
          text: "As the nomination was made by HMRC, it only has effect for a single period of account and therefore a new reporting company ",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "MUST",
          font: defaultFontBold,
        },
        {
          text: " be appointed for the next period of account of the group. As set out above, the appointment must be submitted within the period of 12 months beginning with the end of the period of account of the worldwide group and be authorised by at least 50% of eligible companies during the period of nomination.",
          font: defaultFontNormal,
        },
      ],
    },
  ];

  return [header, ...generateSectionParagraphs(paragraphs)];
};
